import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TSetPaymentQrLink = IAction<EPaymentActions.SET_PAYMENT_QR_LINK, string>

const setPaymentQrLink = (qrLink: string): TSetPaymentQrLink => ({
    type: EPaymentActions.SET_PAYMENT_QR_LINK,
    payload: qrLink,
});

export default setPaymentQrLink;
